import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-start gap-3">
        <span className="mt-1 h-6 w-1 rounded-full bg-accent-500" aria-hidden="true" />
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex flex-shrink-0 items-center gap-1 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}